// extracted by mini-css-extract-plugin
module.exports = {"xstream_h5":"xstream_xstream_h5__lhxHn"};